import React from 'react';
import './footer.css';
import { FaFacebook } from 'react-icons/fa';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer>
            <a href="#" className='footer__logo'>RENALDIN</a>

            <ul className='permalinks'>
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Skills</a></li>
                <li><a href="#portfolio">Portfolio</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <div className="footer__socials">
                <a href="https://web.facebook.com/irjhon.colonel?_rdc=1&_rdr" target="_blank"><FaFacebook /></a>
                {/* <a href="https://www.linkedin.com/in/renaldi-noviandi-422465197/" target="_blank"><BsLinkedin /></a> */}
                <a href="https://github.com/renaldin" target="_blank"><FaGithub /></a>
            </div>

            <div className="footer__copyright">
                <small>&copy; Renaldin. All rights reserved</small>
            </div>
        </footer>
    )
}

export default Footer